import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './styles.css';
import App from './App';
import ReactGA from 'react-ga';

ReactGA.initialize('UA-XXXXXXXXX-X'); // Reemplaza con tu ID de seguimiento de Google Analytics
ReactGA.pageview(window.location.pathname + window.location.search);

ReactDOM.render(<App />, document.getElementById('root'));
